<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="600"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :rules="rules"
      :model="emissionIntensityData"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Emission Intensity Factor:</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="region_name"
              label="Region Name: "
            >
              <el-select
                v-model="emissionIntensityData.region_name"
                placeholder="Select"
                class="w-100"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  <span style="float: left">{{ item }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="name" label="Name: ">
              <el-input
                v-model="emissionIntensityData.name"
                maxlength="64"
                placeholder="e.g. FY 2024-25"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="factor" label="Factor: ">
              <el-input v-model="emissionIntensityData.factor" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="start_date"
              label="Effective from: "
            >
              <el-date-picker
                v-model="emissionIntensityData.start_date"
                type="date"
                format="DD MMM YYYY"
                value-format="YYYY-MM-DD"
                placeholder="Select start date"
                class="dtp-customer w-100"
                prefix-icon=""
              />
            </el-form-item>
          </el-col>

          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="end_date"
              label="Effective till: "
            >
              <el-date-picker
                v-model="emissionIntensityData.end_date"
                type="date"
                format="DD MMM YYYY"
                value-format="YYYY-MM-DD"
                placeholder="Leave empty if current"
                clearable
                class="dtp-customer w-100"
                prefix-icon=""
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="pasteData"
          :disabled="copiedData == null || submitting"
          color="#234B49"
        >
          <i class="fa fa-paste me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Paste</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="confirm"
          :disabled="submitting"
          color="#234B49"
        >
          <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          :disabled="submitting"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// import "animate.css";
import UserService from "../../services/user.service";
import moment from "moment";
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return rawProps;
      },
    },
    copiedDataProp: {
      type: Object,
      default() {
        return null;
      },
    },
    regionList: {
      type: Array,
      default() {
        return [];
      },
    },
    existingVersions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      submitting: false,
      rules: {
        region_name: {
          required: true,
          message: "Please select region name",
          trigger: "blur",
        },
        factor: [
          {
            required: true,
            message: "Please enter factor",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("factor must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        name: {
          max: 64,
          message: "Name must be 64 characters or fewer",
          trigger: "blur",
        },
        start_date: {
          required: true,
          message: "Please select effective from date",
          trigger: "change",
        },
        end_date: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              if (
                this.emissionIntensityData.start_date &&
                value < this.emissionIntensityData.start_date
              ) {
                callback(
                  new Error("Effective till must be on or after Effective from")
                );
                return;
              }
              callback();
            },
          },
        ],
      },
      emissionIntensityData: {
        id: null,
        region_name: "",
        name: "",
        factor: 0,
        start_date: "",
        end_date: null,
      },
      copiedData: null,
    };
  },
  watch: {
    monitoringPeriodsProp: {
      handler: function (newValue) {
        this.monitoringPeriods = newValue;
      },
      deep: true,
    },
    copiedDataProp: {
      handler: function (newValue) {
        this.copiedData = newValue;
      },
      deep: true,
    },
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      this.submitting = false;
      if (newVal == true) {
        this.emissionIntensityData = this.normalizeFormData(this.data_modal);
      }
    },
  },
  methods: {
    normalizeDate(value) {
      if (value == null || value === "") {
        return null;
      }
      return String(value).split("T")[0];
    },
    normalizeFormData(data) {
      const source = data || {};
      return {
        id: source.id ?? null,
        region_name: source.region_name || "",
        name: source.name ?? "",
        factor: source.factor ?? "",
        start_date: this.normalizeDate(source.start_date) || "",
        end_date: this.normalizeDate(source.end_date),
      };
    },
    emptyForm() {
      return {
        id: null,
        region_name: "",
        name: "",
        factor: "",
        start_date: "",
        end_date: null,
      };
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
    pasteData() {
      if (this.copiedData == null) {
        return;
      }
      const currentId = this.emissionIntensityData.id;
      this.emissionIntensityData = {
        ...this.emptyForm(),
        region_name: this.copiedData.region_name || "",
        name: this.copiedData.name ?? "",
        factor: this.copiedData.factor ?? "",
        start_date: this.normalizeDate(this.copiedData.start_date) || "",
        end_date: this.normalizeDate(this.copiedData.end_date),
        id: currentId ?? null,
      };
    },
    isCreate() {
      return (
        this.emissionIntensityData.id == null ||
        this.emissionIntensityData.id === ""
      );
    },
    buildPayload() {
      const endDate = this.normalizeDate(this.emissionIntensityData.end_date);
      return {
        region_name: this.emissionIntensityData.region_name,
        name: String(this.emissionIntensityData.name ?? "").trim(),
        factor: Number(this.emissionIntensityData.factor),
        start_date: this.normalizeDate(this.emissionIntensityData.start_date),
        end_date: endDate,
      };
    },
    findOpenRow(regionName) {
      const list = this.existingVersions || [];
      return list.find(
        (row) =>
          row.region_name === regionName &&
          (row.end_date == null || row.end_date === "") &&
          row.id != null &&
          row.id !== ""
      );
    },
    extractApiError(error) {
      const data = error.response?.data;
      if (!data) {
        return error.message || "Request failed";
      }
      if (typeof data === "string") {
        return data;
      }
      if (typeof data.detail === "string") {
        return data.detail;
      }
      if (Array.isArray(data.detail)) {
        return data.detail
          .map((item) => (typeof item === "string" ? item : item?.msg || JSON.stringify(item)))
          .join(" ");
      }
      const messages = [];
      Object.keys(data).forEach((key) => {
        const value = data[key];
        const text = Array.isArray(value)
          ? value.join(" ")
          : typeof value === "string"
            ? value
            : null;
        if (!text) {
          return;
        }
        if (key === "non_field_errors" || key === "detail") {
          messages.push(text);
        } else {
          messages.push(`${key}: ${text}`);
        }
      });
      return messages.join(" ") || "Request failed";
    },
    handleRequestError(error) {
      console.log(error);
      if (error.response && error.response.status == 401) {
        this.$router.push({
          path: "/",
        });
        return;
      }
      this.$message.error(this.extractApiError(error));
    },
    async confirm() {
      try {
        await this.$refs["ruleFormRef"].validate();
      } catch (fields) {
        console.log("error submit!", fields);
        return;
      }

      const payload = this.buildPayload();
      this.submitting = true;
      try {
        if (this.isCreate()) {
          if (payload.end_date == null) {
            const openRow = this.findOpenRow(payload.region_name);
            if (openRow) {
              if (payload.start_date <= (this.normalizeDate(openRow.start_date) || "")) {
                this.$message.error(
                  "New effective from must be after the current version's start date."
                );
                return;
              }
              const closeDate = moment(payload.start_date, "YYYY-MM-DD")
                .subtract(1, "day")
                .format("YYYY-MM-DD");
              await UserService.updateEmissionIntensity(openRow.id, {
                end_date: closeDate,
              });
            }
          }
          const response = await UserService.createEmissionIntensity(payload);
          this.$emit("confirm_modal", response.data);
          this.$emit("refresh");
        } else {
          const response = await UserService.updateEmissionIntensity(
            this.emissionIntensityData.id,
            payload
          );
          this.$emit("confirm_modal", response.data);
          this.$emit("refresh");
        }
      } catch (error) {
        this.handleRequestError(error);
        this.$emit("refresh");
      } finally {
        this.submitting = false;
      }
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {

  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.dtp-customer > .el-input__wrapper {
  padding: 0 10px !important;
  height: 32px !important;
}
</style>
